import { Form, FormList, LEAD_COLLECTOR_STEPS, useFetchForms } from '@entities/leadCollector';
import { useUpdateEventMutation } from '@pages/event/api/useUpdateEventMutation';
import { LeadCollectorTabHeader } from '@features/leadCollector';
import { useToast } from '@shared/hooks/useToast';
import { useParams } from 'react-router-dom';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { useState } from 'react';

interface ChooseFormProps {
  setStep: (step: number) => void;
  setPrevStep: (step: number) => void;
  hasGeneratedLinks?: boolean;
  onPreviewTemplate: (formId: number) => void;
  selectedForm?: Form;
}

export const ChooseForm = ({
  setStep,
  setPrevStep,
  hasGeneratedLinks,
  onPreviewTemplate,
  selectedForm,
}: ChooseFormProps) => {
  const [chosenForm, setChosenForm] = useState<Form | null>(null);
  const { forms, fetching: fetchingForms } = useFetchForms();
  const [, updateEvent] = useUpdateEventMutation();
  const { showToast } = useToast();
  const { id } = useParams();

  const handleCreateForm = () => {
    setStep(LEAD_COLLECTOR_STEPS.CREATE_FORM);
    setPrevStep(LEAD_COLLECTOR_STEPS.CHOOSE_FORM);
  };

  const handleChooseForm = async () => {
    if (!id || !chosenForm?.id) return;

    const { error } = await updateEvent({ id: Number(id), formId: chosenForm.id });

    if (error) {
      showToast('Произошла ошибка', 'error');
      return;
    }

    setStep(LEAD_COLLECTOR_STEPS.CREATE_LINKS);
  };

  return (
    <div {...stylex.props(styles.container)}>
      <LeadCollectorTabHeader
        title="Выберите шаблон"
        isDisabledChooseForm={!chosenForm || hasGeneratedLinks}
        onChooseForm={handleChooseForm}
        onClickCreateForm={handleCreateForm}
      />
      <FormList
        forms={forms}
        chosenForm={chosenForm}
        setChosenForm={setChosenForm}
        isLoading={fetchingForms}
        onPreviewTemplate={onPreviewTemplate}
        setPrevStep={setPrevStep}
        selectedForm={selectedForm}
      />
    </div>
  );
};
